import { Button } from "@/components/ui/button";
import { STATUS_PRIVATE_OFFICE } from "@/constants/status-private-office";
import { FunnelIcon } from "@heroicons/react/24/outline";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { useFormContext } from "react-hook-form";

interface RightComponentsProps {
  handleSearchSubmit: () => void;
  onFilterClick: () => void;
}

export function RightComponents({
  handleSearchSubmit,
  onFilterClick,
}: RightComponentsProps) {
  const { watch } = useFormContext();
  const filters = watch("filters");
  const searchType = watch("searchType");
  const isSearchByIds = searchType === "privateOfficeIds";

  const activeFilters =
    filters &&
    Object.entries(filters).some(([key, value]) => {
      if (Array.isArray(value)) {
        if (key === "privateOfficeStatus") {
          return !(
            JSON.stringify(value) ===
            JSON.stringify([STATUS_PRIVATE_OFFICE.AVAILABLE.toString()])
          );
        }
        return value.length > 0;
      }
      if (key === "distance" && value === 30) return false;
      if (key === "unitCreditPrice" && value === 80) return false;
      if (key === "skipRecentUpdatesFilter" && value === true) return false;
      return value !== undefined && value !== null && value !== "";
    });

  return (
    <div className="flex gap-2 items-center w-fit">
      <Button size="sm" className="h-10" onClick={handleSearchSubmit}>
        <MagnifyingGlassIcon className="w-4 mr-2" />
        Buscar
      </Button>

      <div style={{ position: "relative", display: "inline-block" }}>
        <Button
          size="sm"
          className="h-10 px-4 pr-6 flex items-center justify-center gap-2"
          onClick={onFilterClick}
          variant="outline"
          disabled={isSearchByIds}
        >
          <FunnelIcon className="w-4 mr-2" />
          Filtrar
        </Button>
        {activeFilters && !isSearchByIds && (
          <span
            style={{
              position: "absolute",
              top: "50%",
              right: 0,
              gap: 8,
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 16,
              height: 16,
              pointerEvents: "none",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M7.99988 5.96667C9.12282 5.96667 10.033 6.87695 10.0331 7.99987C10.0331 9.12285 9.12286 10.0331 7.99988 10.0331C6.87695 10.033 5.96667 9.12281 5.96667 7.99987C5.96675 6.87699 6.877 5.96674 7.99988 5.96667Z"
                fill="#E63D36"
                stroke="#E63D36"
              />
            </svg>
          </span>
        )}
      </div>
    </div>
  );
}
